export default __webpack_public_path__ + "static/media/doneMark.5b7f3332.svg";